<template>
  <v-app id="pubmap" :style="{height: appHeight}">
    <mobile-footer v-if="$vuetify.breakpoint.mobile"></mobile-footer>

    <mobile-layer-control :value="showMobileLayerControl" v-if="$vuetify.breakpoint.mobile"></mobile-layer-control>

    <the-toolbar></the-toolbar>
    <the-sidebar></the-sidebar>
    <v-main>
        <invalid-notification v-if="CONFIG && CONFIG.invalid"
                              :reason="CONFIG.reason"
                              :systype="CONFIG.systype"></invalid-notification>

      <v-container fluid class="pa-0 fill-height" v-if="CONFIG && !CONFIG.invalid">
          <the-map v-if="CONFIG.orgid"></the-map>
      </v-container>
      <the-footer v-if="CONFIG && !CONFIG.invalid && !$vuetify.breakpoint.mobile && CONFIG.config.footer"></the-footer>
    </v-main>
  </v-app>
</template>

<script>
  import { mapGetters } from 'vuex';
  import TheMap from './components/Map/TheMap';
  import InvalidNotification from './components/InvalidNotification';
  import TheToolbar from './components/ToolBar/TheToolbar';
  import TheSidebar from './components/SideBar/TheSidebar';
  import TheFooter from './components/Footer/TheFooter';
  import MobileFooter from '@/components/Footer/MobileFooter.vue';
  import MobileLayerControl from '@/components/LayerControl/MobileLayerControl.vue';

  export default {
    name: 'app',


    computed: {
      ...mapGetters({
        CONFIG: 'CONFIG',
        TOOLS: 'TOOLS'
      }),
      isMobile () { return this.$vuetify.breakpoint.name},
      appHeight () {return window.innerHeight + 'px'},
      primaryColor () {
        return this.$vuetify.theme.themes.light['primary']
      },
    },

    watch: {
      CONFIG: {
        handler (after, before){
          /**
           * Apply custom colours if set
           */
          if (after.config && after.config.colours){
            for (let colour in after.config.colours){
              this.$vuetify.theme.themes.light[colour] = after.config.colours[colour];
            }
          }
        }
      }
    },

    async mounted() {
      if (this.isTooDark(this.$vuetify.theme.themes.light['primary'])){
        console.log("TOO DARK")
        this.$store.commit('SET_APP_TEXT_COLOUR','white')
      }
      await this.$store.dispatch('FETCH_CONFIG');
    },

    methods: {
    },

    data: () => ({
      map: null,
      showMobileLayerControl: false,
    }),
    components: {
      MobileLayerControl,
      MobileFooter,
      TheFooter,
      TheSidebar,
      TheToolbar,
      InvalidNotification,
      TheMap
    },
  };
</script>

<style>

.v-application--wrap {
  min-height: 100%;
}

  html, body {
    overflow-y: hidden;
  }
</style>
